<template>
  <el-container class="communicat_stat" >
    <el-header class="header-style">
    <el-divider content-position="left">沟通管理</el-divider>
    <div class="changeHeight m-tabs-content">
      <el-row type="flex" >
        <el-col :span="2"   class="tr m-label text_right">选择日期</el-col>
        <el-col :span="6">
          <div>
            <el-date-picker
              v-model="value1"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="pickerDataChange"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="2"  :offset="2" class="tr m-label text_right">选择人员</el-col>
        <el-col :span="6" >
          <el-select
            :filterable="true"
            multiple
            collapse-tags
            v-model="highSearch.uid"
            placeholder="请选择人员"
            size="mini"  clearable>
            <el-option
              v-for="(item, index) in ConversionPeople"
              :key="index"
              :label="item.username"
              :value="item.id" >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="tr">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="display: flex">
            <div class="count_style">
              <span class="count" style="margin-right: .2rem;padding-left: 0;">沟通日期：{{communicatStat.communicate_date}}</span>
              <span class="count" style="margin-right: .2rem;">今日累积分配：{{communicatStat.all_get}}</span>
              <span class="count" style="margin-right: .2rem">今日累积沟通：{{communicatStat.all_communicat}}</span>
              <span class="count" style="margin-right: .2rem">今日累积建议：{{communicatStat.all_suggest}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-header>
  <el-main class="main-style">
    <el-table v-if="!loadingStatus" :data="pageData"  @sort-change="sortChange" size="medium" style="width: 100%;" border>
      <el-table-column fixed label="区域" prop="department" fixed></el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :fixed="index < 1"
        sortable="custom"
        :min-width="tableColumnMin(item.prop)">
        <template slot-scope="scope">
          <div style="cursor: pointer;width: 100%" v-if="item.prop === 'username'" :content="scope.row[item.prop] + ''">
            <span @click="handleFlagDetail(scope.row.uid)" class="dot" style="display: inline-block;color: #5787FF">{{scope.row.username}}</span>
          </div>
          <div v-else :content="scope.row[item.prop]">
            <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" v-if="false">
      </el-table-column>
    </el-table>
    <div v-else class="loading-placeholder">加载中，请稍后...</div>
  </el-main>

    <el-drawer
      title="今日沟通情况"
      :visible.sync="ContactDrawer"
      direction="rtl"
      :before-close="handleAddDrawerBeforeClose"
      size="80%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="24">
            <div style="display: flex">
              <span class="count" style="margin-right: .2rem">姓名：<span style="color: rgb(87, 135, 255);;">{{header.username}}</span></span>
              <span class="count" style="margin-right: .2rem">沟通日期：{{header.current_date}}</span>
              <span class="count" style="margin-right: .2rem">今日成交：{{header.success}}</span>
              <span class="count" style="margin-right: .2rem">未知意向：{{header.unknown}}</span>
              <span class="count" style="margin-right: .2rem">A：{{header.a}}</span>
              <span class="count" style="margin-right: .2rem">B：{{header.b}}</span>
              <span class="count" style="margin-right: .2rem">C：{{header.c}}</span>
              <span class="count" style="margin-right: .2rem">D：{{header.d}}</span>
              <span class="count" style="margin-right: .2rem">E：{{header.e}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div style="display: flex">
              <span class="count" style="margin-right: .2rem">今日领取：{{dayChange.person_get}}</span>
              <span class="count" style="margin-right: .2rem">今日分配：{{dayChange.allot_get}}</span>
              <span class="count" style="margin-right: .2rem">今日总放弃：{{dayChange.give_up}}</span>
              <span class="count" style="margin-right: .2rem">今日领取今日放弃：{{dayChange.current_day_give_up}}</span>
              <span class="count" style="margin-right: .2rem">今日领取今日沟通：{{dayChange.communicat}}</span>
              <span class="count" style="margin-right: .2rem">今日领取沟通率：{{dayChange.execute_rate + '%'}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="19">
            <div style="display: flex">
              <span class="count" style="margin-right: .2rem">今日建议：{{header.suggest}}</span>
              <span class="count" style="margin-right: .2rem">今日电话联系：{{header.phone}}</span>
              <span class="count" style="margin-right: .2rem">今日微信沟通：{{header.wechat}}</span>
            </div>
          </el-col>
          <el-col :span="5" class="tr">
            <el-date-picker
              v-model="selectMonth"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="handleSelectMonth">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-table :data="pageDataMonth" @sort-change="sortChange" max-height="600" size="medium" style="width: 100%">
          <el-table-column fixed label="时间"  width="180" prop="created_time">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.created_time" placement="top">
                <span  class="count_style" style="display: inherit">{{scope.row.created_time}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="160"
            v-for="(item, index) in colMonth"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            sortable="custom"
            :min-width="tableColumnMonthMin(item.prop)">
            <template slot-scope="scope">
              <el-tooltip v-if="item.prop === 'communicat_type'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-if="item.prop === 'tag_code'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'custom_phone'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'call_duration'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'intention'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <span v-else-if="item.prop === 'record_file_download_url'" class="count_style" style="display: inherit">
                <i v-if="scope.row[item.prop]" class="el-icon-mic" style="color: #5789f4; font-size: 30px; cursor: pointer;" @click="windowOpenVideo(scope.row.file_storage, scope.row[item.prop])"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="沟通反馈"  min-width="160" prop="communication_note">
            <template slot-scope="scope">
              <el-popover
                placement="right"
                v-if="activitiesShow"
                @show="popoverMethods(scope.row.communication_id)"
                trigger="click"
                width="500">
                <div class="popoverList block" >
                  <el-timeline >
                    <el-timeline-item
                      class="time_class"
                      v-if="activitiesShow"
                      :icon="activitiesShow.icon"
                      :type="activitiesShow.type"
                      :color="activitiesShow.color"
                      :size="activitiesShow.size">
                      <span style="color: #666666;  display: inline-block; margin-bottom: .2rem">{{activitiesShow.uname+ '于' }}</span>
                      <span style="color: #666666;">{{activitiesShow.created_time}}</span>
                      <span style="color: #666666;">{{activitiesShow.communicat_type}}</span>
                      <div class="time_right time_line">
                        <span>{{activitiesShow.communication_note}}</span>
                      </div>
                      <div class="time_right">
                        <el-link
                          class="handleLinkImg"
                          v-for="(items, indexs) in activitiesShow.preview"
                          :key="indexs"
                          @click="handleLinkImgS(indexs)"
                          type="primary">
                          {{'图片' + (indexs + 1)}}
                        </el-link>
                      </div>
                      <div class="m_comment public"
                           v-if="activitiesShow.son"
                           v-for="(item, id) in activitiesShow.son"
                           :key="id">
                        <div class="comment_name_time">
                          <span class="comment_name">{{item.username}}</span>
                          <span class="comment_time">{{item.created_at}}</span>
                        </div>
                        <div class="comment_content">
                          <span class="cot">{{item.communicat_content}}</span>
                        </div>
                      </div>
                      <div class="comment_textarea" v-if="commentVisible" style="margin-bottom: .2rem;margin-top: .2rem">
                        <el-input
                          type="textarea"
                          placeholder="请输入要回复的信息"
                          :autosize="textareaSize"
                          style="font-size: .28rem"
                          v-model="addCommentData.communicat_content"/>
                      </div>
                      <div style="width: 100%;text-align: right;">
                        <el-button size="mini" type="primary" v-if="buttonVisible" @click="handleComment(activitiesShow)">回复</el-button>
                        <el-button size="mini" type="primary" v-else @click="handleCommentConfirm(activitiesShow)">保存</el-button>
                      </div>
                    </el-timeline-item>
                    <div v-if="!activitiesShow">没有记录</div>
                  </el-timeline>
                </div>
                <span class="count_style popoverSpan" style="display: inherit;cursor: pointer;" slot="reference" >
                  <i v-if="scope.row.communicat_icon !== 0" class="el-icon-chat-dot-square"></i>
                  {{scope.row.communication_note}}
                </span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="" width="20">
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-dialog title="播放" :visible.sync="dialogPlayVisible" :before-close="dialogPlayVisibleBeforeClose">
      <el-row class="playCon">
        <el-card class="card" :body-style="{ padding: '10px' }">
          <div id="waveform" ref="waveform"></div>
        </el-card>
        <div style="padding: 10px" id="wave-timeline" ref="wave-timeline"></div>
      </el-row>
      <div class="text-c">
        <el-button type="primary" @click="playMusic" size="mini">
          <i :class="[isPlay ? 'el-icon-video-pause' : 'el-icon-video-play']"></i>
          {{isPlay ? '暂停' : '播放'}}
        </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import WaveSurfer from 'wavesurfer.js'
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js'
export default {
  name: 'communicat_stat',
  data () {
    return {

      commentVisible: false,
      buttonVisible: true,
      addCommentData: {
        id: '',
        uid: '',
        communicat_content: ''
      },
      textareaSize: { minRows: 4, maxRows: 2 },
      percentNum: '',
      count: '',
      cluesNum: '',
      cluesIndex: 0,
      FlagManage: [],
      FlagManageMonth: [],
      OperationRecord: [],
      ContactDrawer: false,
      loadingStatus: true,
      search: '',
      value1: '',
      options: [],
      ConversionPeople: [],
      activities: [],
      highSearch: {
        dateTime: '',
        uid: []
      },
      optionProps: {
        value: 'id',
        label: 'Provincial',
        children: 'son'
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      pageOptionMonth: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      dialogVisible3: false,
      col: [
        {
          label: '姓名',
          prop: 'username',
          display: false
        },
        // {
        //   label: '日期',
        //   prop: 'date_time',
        //   display: false
        // },
        {
          label: '外呼次数',
          prop: 'call_count',
          display: false
        },
        {
          label: '沟通个数',
          prop: 'communicat_nums',
          display: false
        },
        {
          label: '订单沟通个数',
          prop: 'order_communicat_nums',
          display: false
        },
        {
          label: '沟通时长',
          prop: 'call_duration',
          display: false
        },
        {
          label: '平均沟通时长',
          prop: 'avg_duration',
          display: false
        }
      ],
      colMonth: [
        {
          label: '沟通方式',
          prop: 'communicat_type',
          display: false
        },
        {
          label: '线索编码',
          prop: 'tag_code',
          display: false
        },
        {
          label: '客户手机号码',
          prop: 'custom_phone',
          display: false
        },
        {
          label: '沟通时长',
          prop: 'call_duration',
          display: false
        },
        {
          label: '客户意向',
          prop: 'intention',
          display: false
        },
        {
          label: '沟通内容',
          prop: 'record_file_download_url',
          display: false
        }
      ],
      activeName: 'first',
      combo: [],
      items: [],
      tabData: [],
      couldMealItem: {},
      selectMonth: '',
      selectMonthId: null,
      header: {
        user_name: '',
        ok_count: '',
        not_count: '',
        all_count: '',
        any_refund_money: '',
        reaching: ''
      },
      activitiesShow: {},
      dayChange: {},
      communicatStat: {
        communicate_date: '',
        all_communicat: '',
        all_get: '',
        all_suggest: ''
      },
      wavesurfer: null,
      dialogPlayVisible: false,
      isPlay: false
    }
  },
  computed: {
    pageData: function () {
      return this.FlagManage
    },
    pageDataMonth: {
      get: function () {
        return this.FlagManageMonth
      }
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.tabData.length
      this.pageOption.currentPage2 = 1
    }
  },
  methods: {
    handleComment (activity) {
      this.commentVisible = true
      this.buttonVisible = false
    },
    handleCommentConfirm (activity) {
      if (!this.addCommentData.communicat_content) {
        this.$message.error('沟通内容不能为空')
        return
      }
      this.$axios.post('/api/thread/return_communicat/' + activity.communication_id,
        {
          uid: activity.uid,
          communicat_content: this.addCommentData.communicat_content
        })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.activitiesShow.son.push(data.data)
            this.handleCommentConfirmClose()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCommentConfirmClose () {
      this.addCommentData.communicat_content = ''
      this.addCommentData.uid = ''
      this.commentVisible = false
      this.buttonVisible = true
    },
    popoverMethods (id) {
      this.$axios.get('/api/thread/communicat_show/' + id)
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.handleForMethodsShow(id, data.data)
          }
        })
    },
    enter (id) {},
    handleLinkImgS (indexs) {
      var tempwindow = window.open('_blank')
      tempwindow.location = this.activitiesShow.preview[indexs]
    },
    handleForMethodsShow (id, data) {
      for (var i = 0; i < this.pageDataMonth.length; i++) {
        if (id === this.pageDataMonth[i].communication_id) {
          this.activitiesShow = data
          if (this.activitiesShow.communicat_type === 1) {
            this.activitiesShow.communicat_type = '通过 ' + this.getFeedBack(data.communicat_type) + '与客户沟通了' + data.call_duration + '秒'
          } else {
            this.activitiesShow.communicat_type = '通过 ' + this.getFeedBack(data.communicat_type) + '与客户进行了沟通'
          }
          if (data.communicat_img) {
            this.activitiesShow.preview = data.communicat_img.split(',')
          }
          this.activitiesShow.size = 'large'
          this.activitiesShow.type = 'primary'
          this.activitiesShow.icon = 'el-icon-s-custom'
        }
      }
    },
    getFeedBack (key) {
      let vipData = [' ', '电话联系', '手机短信', '发送快递', '微信交流', '见面拜谈', '公司洽谈', '优开平台']
      return vipData[key]
    },
    handleSelectMonth (val) {
      this.selectMonth = val
      this.handleFlagDetailMethods(this.selectMonthId)
    },
    handleFlagDetail (id) {
      this.ContactDrawer = true
      this.selectMonthId = id
      this.handleFlagDetailMethods(id)
    },
    handleFlagDetailMethods (id) {
      this.$axios.get('/api/threadstat/user_communicat/' + id, {
        params: {
          year_month: this.selectMonth
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.FlagManageMonth = data.data.list
            this.header = data.data.header
            this.dayChange = data.data.dayChange
          }
        })
    },
    sortChange (column) {
      if (column.order === 'descending') {
        this.handelGetOrders(
          this.highSearch.dateTime,
          this.highSearch.uid,
          column.prop,
          0
        )
      } else if (column.order === 'ascending') {
        this.handelGetOrders(
          this.highSearch.dateTime,
          this.highSearch.uid,
          column.prop,
          1
        )
      } else {
        this.handelGetOrders(
          this.highSearch.dateTime,
          this.highSearch.uid,
          '',
          ''
        )
      }
    },
    tableColumnMin (prop) {
      let width = ''
      if (prop === 'username') {
        width = 100
      }
      if (prop === 'all_royalty') {
        width = 140
      }
      if (prop === 'combo_status' || prop === 'cloud_status') {
        width = 160
      }
      let vipData = ['cloud_count', 'item_count', 'meal_count', 'target_cloud', 'target_combo', 'cloud_royalty', 'combo_royalty', 'item_royalty']
      if (vipData.indexOf(prop) !== -1) {
        width = 150
      }
      if (prop === 'avg_duration' || prop === 'order_communicat_nums' || prop === 'call_count' || prop === 'communicat_nums' || prop === 'call_duration') {
        width = 140
      }
      return width
    },
    tableColumnMonthMin (prop) {
      let width = ''
      let vipData = ['target_combo', 'combo_count', 'cloud_count', 'target_cloud', 'cloud_refund', 'meal_refund', 'item_refund', 'complete']
      if (vipData.indexOf(prop) !== -1) {
        width = 120
      }
      if (prop === 'cloud_refund_money' || prop === 'meal_refund_money' || prop === 'item_refund_money') {
        width = 130
      }
      return width
    },
    provinceCityData () {
      this.$axios.get('/api/thread/cities')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            for (var a = 0; a < data.data.length; a++) {
              this.options.push(data.data[a])
            }
          }
        })
    },
    // handleClick (tab, event) {
    //   // console.log(tab, event)
    // },
    handleAddDrawerBeforeClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData()
          done()
        })
        .catch(_ => {})
    },
    clearAddData () {
      this.activities = []
      this.OperationRecord = []
      this.selectMonth = ''
    },
    handelGetSerach () {
      this.$axios.get('/api/threadstat/combo_items', {})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.combo = data.data.combo
            this.items = data.data.items
          }
        })
    },
    handelGetOrders (dateTime, Uid, Field, orderBy) {
      this.$axios.post('/api/threadstat/communicat_stat', {
        date_time: dateTime,
        uids: Uid,
        field: Field,
        order_by: orderBy
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.FlagManage = data.data.list
            this.ConversionPeople = data.data.user
            this.communicatStat = data.data.communicatStat
            this.pageOption.total = this.FlagManage.length
          }
        }).finally(() => {
          this.loadingStatus = false
        }).catch(err => {
          this.loadingStatus = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
    },
    handleSizeChangeMonth (val) {
      this.pageOptionMonth.pageSize = val
    },
    handleCurrentChangeMonth (val) {
      this.pageOptionMonth.currentPage = val
    },
    searchTotal () {
      return this.FlagManage.filter(data => !this.search || (data.custom_name && data.custom_name.toLowerCase().includes(this.search.toLowerCase())) || (data.custom_phone && data.custom_phone.toLowerCase().includes(this.search.toLowerCase()))).length
    },
    groupInput (val) {
      this.highSearch.group_chat_id = val
    },
    pickerDataChange (val) {
      // console.log(val)
      if (!val) {
        this.highSearch.dateTime = ''
      } else {
        this.highSearch.dateTime = val
      }
    },
    handleSearch () {
      this.handelGetOrders(
        this.highSearch.dateTime,
        this.highSearch.uid
      )
    },
    handleCloseSearch () {
      this.value1 = ''
      this.highSearch.dateTime = ''
      this.highSearch.uid = []
      this.handelGetOrders(
        this.value1,
        this.highSearch.uid
      )
    },
    windowOpenVideo (isStorage, url) {
      if (!url) {
        this.$message.error('录音为空')
        return
      }

      if (!isStorage) {
        window.open(url)
        return
      }

      this.$axios.post('/api/admin/callLogs/getObject', {filePath: url})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.dialogPlayVisible = true
            this.waveSurferInit(data.data)
          }
        })
    },
    waveSurferInit (src) {
      this.$nextTick(() => {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs.waveform,
          barWidth: 1,
          cursorColor: 'black',
          progressColor: 'blue',
          backend: 'MediaElement',
          audioRate: '1',
          plugins: [
            Timeline.create({
              container: '#wave-timeline'
            })
          ]
        })
        this.wavesurfer.load(src)
        let that = this
        this.wavesurfer.on('finish', function () {
          that.isPlay = false
        })
      })
    },
    playMusic () {
      this.wavesurfer.playPause.bind(this.wavesurfer)()
      this.isPlay = this.wavesurfer.isPlaying()
    },
    dialogPlayVisibleBeforeClose (done) {
      this.isPlay = false
      this.wavesurfer.destroy()
      done()
    },
    handleChangeHeight (val) {}
  },
  mounted () {
    this.handelGetOrders()
    this.handelGetSerach()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span {
    color: #5789F4;
    font-size: 0.36rem;
    font-weight: 400;
  }
  .public
    box-sizing border-box
    display flex
    width 100%
  .communicat_stat
    marginLeft()
    max-height: 100vh
    .header-style
      z-index: 2
      height: 148px !important
      padding: 0px !important
    .main-style
      z-index: 1
      padding: 0px !important
      overflow-y: auto
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .tr
    text-align: right
  .m-tabs-content
    overflow-y auto
    padding 0 .4rem
    box-sizing border-box
    .m-label
      line-height: .64rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
  .communicat_stat >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  /*.clues_manage >>> .el-table__header thead .is-hidden*/
  /*  color: red*/
  /*  background-color: #ECF4FF*/
  /*  font-size 16px*/
  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem
  .mt-10
    margin-top: .2rem
  .level
    display flex
    align-items center
    position relative
    padding-right .32rem
    img
      width .32rem
      height .30rem
    .el-icon-question
      margin-left: .1rem
      color: #409EFF
      position absolute
      top 0
      right 0
      cursor pointer
  .el-select, .el-cascader
    width: 100%
  .count
    padding-left: .2rem
    line-height: .56rem
  .el-position
    position relative
    .dot
      display inline-block
      width 0.1rem
      height 0.1rem
      border-radius 50%
      margin-right 0.1rem
      position absolute
      top 0
      left -.2rem
      bottom 0
      margin auto
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .changeHeight
    padding .2rem
    margin-top .4rem
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .el-collapse >>> .el-collapse-item__content
    padding-bottom 0
  .el_dialogs >>> .el-dialog__body
    padding-left 0
    padding-right 0
  .el_dialogs >>> .el-dialog__header
    padding 0
  .el-icon-chat-dot-square
    color: #88D023
  .block
    height auto
    overflow-y auto
    padding-top .2rem
    padding-left .2rem
    box-sizing border-box
    .m_comment
      padding .2rem .4rem
      flex-direction column
      margin-bottom .2rem
      background #f3f3f3
      height auto
      border-radius .09rem
      .comment_name_time
        margin-bottom .4rem
        display flex
        flex-direction row
        justify-content space-between
        line-height .5rem
        span
          color: rgb(102, 102, 102)

    .time_right
      width 100%
      margin-top .4rem
      overflow hidden
      word-break break-all
      white-space normal
    .time_line
      line-height .5rem
  .popoverSpan:hover
    color: rgb(87, 135, 255)
  .el-timeline-item__node--large
    width .4rem
    height .4rem
  /*滚动条整体样式*/
  ::-webkit-scrollbar{
    width: .1rem;/*竖向滚动条的宽度*/
    height: 10px;/*横向滚动条的高度*/
  }
  ::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track{/*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .el-date-editor
    width: 100% !important
  .loading-placeholder {
    text-align: center;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/communicat_stat/communicat_stat.vue